import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { fetchFilterData } from "./filterAPI";
import { RootState } from "../../state/store";
import { setUpdatedStates } from "../map/mapSlice";

export interface FilterState {
  enabledKeys: Record<string, any[]>;
  disabledKeys: Record<string, any[]>;
  currentSelection: Record<string, any[]>;
  previousSelection: Record<string, any[]>;
  loading: boolean;
}

const initialState: FilterState = {
  enabledKeys: {},
  disabledKeys: {},
  currentSelection: {},
  previousSelection: {},
  loading: false,
};

export const fetchFilters = createAsyncThunk(
  "filters/fetchFilters",
  async (payload: any, { dispatch }) => {
    const response = await fetchFilterData(payload);
    dispatch(setUpdatedStates(response.data.enabled_keys.state));
    return response.data;
  }
);

const filterSlice = createSlice({
  name: "filters",
  initialState,
  reducers: {
    resetFilters: () => {
      return initialState;
    },
    updateSelection: (
      state,
      action: PayloadAction<{ key: string; value: any[] }>
    ) => {
      const { key, value } = action.payload;
      state.currentSelection[key] = value;
    },
    syncPreviousSelection: (state) => {
      state.previousSelection = JSON.parse(
        JSON.stringify(state.currentSelection)
      );
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchFilters.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchFilters.fulfilled, (state, action) => {
      state.loading = false;
      state.enabledKeys = action.payload.enabled_keys;
      state.disabledKeys = action.payload.disabled_keys;

      state.previousSelection = { ...state.currentSelection };
    });
    builder.addCase(fetchFilters.rejected, (state) => {
      state.loading = false;
    });
  },
});

export const { updateSelection, syncPreviousSelection, resetFilters } =
  filterSlice.actions;

export const selectEnabledKeys = (state: RootState, filterKey: string) =>
  state.filters.enabledKeys[filterKey] || [];
export const selectDisabledKeys = (state: RootState, filterKey: string) =>
  state.filters.disabledKeys[filterKey] || [];
export const selectLoading = (state: RootState) => state.filters.loading;

export default filterSlice.reducer;
